import { PANEL_STATUS } from './panelStatus';

export const MAINTENANCE_PANEL_STATUS = PANEL_STATUS;

// Frozen shared constants: a pane that is not ready always receives the same object, so a re-render cannot
// change its props.
export const MAINTENANCE_PANEL_LOADING = Object.freeze({ status: PANEL_STATUS.LOADING, maintenance: null });
const MAINTENANCE_PANEL_FAILED = Object.freeze({ status: PANEL_STATUS.FAILED, maintenance: null });
const MAINTENANCE_PANEL_UNAVAILABLE = Object.freeze({ status: PANEL_STATUS.UNAVAILABLE, maintenance: null });

// `product` is the machine's entry of the batch map, or undefined when the batch has not returned it. `maintenance`
// is null for a machine without maintenance and undefined when rest-api did not send the field. `loaded` says a
// batch reply has been processed, so a product the reply left out is unavailable rather than loading forever. A
// maintenance already known is never replaced by the failure line: a later failed batch keeps it.
export const buildMaintenancePanel = (product, { loaded, loadFailed }) => {
	if (product && product.maintenance !== undefined) {
		return Object.freeze({ status: PANEL_STATUS.READY, maintenance: product.maintenance });
	}

	if (loadFailed) {
		return MAINTENANCE_PANEL_FAILED;
	}

	return loaded ? MAINTENANCE_PANEL_UNAVAILABLE : MAINTENANCE_PANEL_LOADING;
};
